module.exports = __webpack_public_path__ + "static/media/icon-emoji-sad.822ea2da.svg";